import type { HttpQueryParam, IHttpClient } from "@/core/interfaces";
import { Registry } from "@/shared/infra/dependency-injection/registry";

import {
  cabecalhoIdempotencia,
  readEnvelopeData,
} from "../financeiro-obras/financeiro-obras.gateway";
import type {
  LookupRequestOptions,
  OpcoesMutacao,
} from "../financeiro-obras/financeiro-obras.gateway";
import type {
  CadastrarCurvaBody,
  CurvaItem,
  CurvaMutada,
  EditarCurvaBody,
  ListarCurvasParams,
  SituacaoCurva,
  SituacaoCurvaAlterada,
} from "./financeiro-configuracoes.curvas.types";

export const CURVAS_MENSALIZACAO_PATHS = {
  CURVAS: "/api/financeiro/configuracoes/curvas-mensalizacao",
  CURVA: (curvaId: string) =>
    `/api/financeiro/configuracoes/curvas-mensalizacao/${encodeURIComponent(curvaId)}`,
  SITUACAO_CURVA: (curvaId: string) =>
    `/api/financeiro/configuracoes/curvas-mensalizacao/${encodeURIComponent(curvaId)}/situacao`,
} as const;

function getHttpClient(): IHttpClient {
  return Registry.getInstance().inject<IHttpClient>("HttpClient");
}

export async function listarCurvas(
  { categoria, incluirInativas }: ListarCurvasParams = {},
  { signal }: LookupRequestOptions = {},
): Promise<CurvaItem[]> {
  const params: Record<string, HttpQueryParam> = {};
  if (categoria) params.categoria = categoria;
  if (incluirInativas !== undefined) params.incluirInativas = incluirInativas;

  const response = await getHttpClient().get<unknown>(CURVAS_MENSALIZACAO_PATHS.CURVAS, {
    params,
    signal,
  });
  const curvas = readEnvelopeData<CurvaItem[]>(response.data);
  if (!Array.isArray(curvas)) throw new Error("Resposta inválida do bff.");
  return curvas;
}

export async function cadastrarCurva(
  body: CadastrarCurvaBody,
  { idempotencyKey }: OpcoesMutacao = {},
): Promise<CurvaMutada> {
  const response = await getHttpClient().post<unknown>(CURVAS_MENSALIZACAO_PATHS.CURVAS, body, {
    headers: cabecalhoIdempotencia(idempotencyKey),
  });
  return readEnvelopeData<CurvaMutada>(response.data);
}

export async function editarCurva(
  curvaId: string,
  body: EditarCurvaBody,
  { idempotencyKey }: OpcoesMutacao = {},
): Promise<CurvaMutada> {
  const response = await getHttpClient().put<unknown>(
    CURVAS_MENSALIZACAO_PATHS.CURVA(curvaId),
    body,
    {
      headers: cabecalhoIdempotencia(idempotencyKey),
    },
  );
  return readEnvelopeData<CurvaMutada>(response.data);
}

export async function alterarSituacaoCurva(
  curvaId: string,
  situacao: SituacaoCurva,
  { idempotencyKey }: OpcoesMutacao = {},
): Promise<SituacaoCurvaAlterada> {
  const response = await getHttpClient().patch<unknown>(
    CURVAS_MENSALIZACAO_PATHS.SITUACAO_CURVA(curvaId),
    { situacao },
    { headers: cabecalhoIdempotencia(idempotencyKey) },
  );
  return readEnvelopeData<SituacaoCurvaAlterada>(response.data);
}
